export default __webpack_public_path__ + "static/media/head03_zh_cn_pc.06071fd9.png";